// extracted by mini-css-extract-plugin
export var sliderRange = "_rf-2";
export var sliderRoot = "_rf-0";
export var sliderThumb = "_rf-3";
export var sliderTrack = "_rf-1";